/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// toggleFilterDrawer()
$(".label--filter").click(toggleFilterDrawer);
$(".about-vendor-container").click(function (e) {
  var t = $(this);
  toggleMoreAboutVendor(t);
});

var $qtySelector = $(".quantity-btn-wrapper .quantity-selector");
var $qtyInput = $qtySelector.find(".qty-value");
var $btns = $qtySelector.find(".qty-btn");

$btns.on("click", function (e) {
  e.preventDefault();
  var action = $(this).data("action");
  console.log("action", action);
  var quantity = parseInt($qtyInput.val(), 10);

  if (action === "plus" && quantity < 99) {
    quantity++;
  } else if (action === "minus" && quantity > 1) {
    quantity--;
  }

  $qtyInput.val(quantity);
});

var previousHeight = 0;

var intervalId = setInterval(function () {
  var totalHeight = $(".site-header").outerHeight(true) || 0;
  var fsbh = 0;
  var sHeight = $(".site-header").outerHeight(true);
  if ($("#fsb_bar").length) {
    totalHeight += $("#fsb_bar").outerHeight(true);
    fsbh = $("#fsb_bar").outerHeight();
    $(".site-header").css("top", fsbh + "px");
  }
  console.log("heyy", totalHeight);

  // Only update if the height has changed
  if (totalHeight !== previousHeight) {
    $(".main-content").css("margin-top", sHeight + "px");
    previousHeight = totalHeight;
  }
  if ($("#fsb_bar").length && totalHeight === previousHeight) {
    clearInterval(intervalId);
  }
}, 200);

function toggleFilterDrawer() {
  $(".filters-drawer-wrapper").toggleClass("active");
  $(".label--filter").toggleClass("active");
}

function toggleMoreAboutVendor(t) {
  $(t).toggleClass("active");
}

$(".filter-item").click(function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $("[tag-category=" + $(this).attr("tag-category") + "]").removeClass(
      "active"
    );
    $(this).addClass("active");
  }
});

// Filter button functionality
$("#filter_btn").click(function () {
  let active_filters = document.getElementsByClassName("filter-item active");
  let tags = [...active_filters].map((x) => x.getAttribute("tag-name"));
  let tags_params = tags.join(" ");
  let path_array = location.href.split("/");

  // remove the last params if exist
  if (path_array[path_array.length - 1] != "all-natural-wines") {
    path_array.pop();
  }

  // add new filters to url array
  path_array.push(tags_params);
  // create new url
  let new_url = path_array.join("/");

  location.href = new_url;
});

var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function (e) {
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");

          // Trigger the change event
          var event = new Event("change", { bubbles: true });
          s.dispatchEvent(event);

          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

// const isCollectionOrProductPages = ($('body').hasClass('template-collection') && !$('.collection-template').hasClass('collection-vendor-template')) || $('body').hasClass('template-product');
const isProductPage = $("body").hasClass("template-product");
// document.cookie = "asisPopup=";
console.log('j',isProductPage);
if (isProductPage  === -1) {
  setTimeout(openHelpPopup, 5000);

} else {

  console.log("cookie is set");
}

if (!sessionStorage.alreadyClicked && $(".free-text-popup").length > 0) {
  console.log("jjj");
  setTimeout(openTextPopup, 2000);
  
}

$(".close-popup").click(closePopup);

function openHelpPopup() {
  $(".help-popup").addClass("active");
  document.cookie = "asisPopup=true";
}

function openTextPopup() {
  $(".free-text-popup").addClass("active");
  sessionStorage.alreadyClicked = 1;
}

function closePopup() {
  $(".popup").fadeOut();
}

$(".quantity-selector option").each(function () {
  console.log($(this).val());
  console.log($(this).parent().val());

  if ($(this).val() === $(this).parent().attr("value")) {
    $(this).attr("selected", "selected");
  }
});

$(document).ready(function ($) {
  var checkHeightInterval = setInterval(function () {
    var $fsb = $("#fsb_container");

    if ($fsb.length > 0) {
      var heightAnnoucement = $fsb.outerHeight();

      // Stop if the height is found and not zero
      if (heightAnnoucement > 0) {
        var heightHeader = parseInt($(".site-header").outerHeight());
        $(".site-header").css("top", heightAnnoucement + "px");

        $(".main-content").css("margin-top", heightHeader + "px");
        clearInterval(checkHeightInterval);
      }
    }
  }, 200); // Check every 200ms

  //remove en class from product titles if it doesn't include english, so that the hebrew font will apply to them
  if ($(".product__title")) {
    if (!$(".product__title").text().match(/[a-z]/i)) {
      $(".product__title").removeClass("en");
    }
  }

  if ($(".card__name")) {
    if (!$(".card__name").text().match(/[a-z]/i)) {
      $(".card__name").removeClass("en");
    }
  }

  jQuery(".site-header__navigation.btn").click(function () {
    jQuery("html").css("background", "#f7e1d1");
  });

  $("[name='checkbox-list']").click(function (event) {
    event.preventDefault();
  });

  if ($("body").hasClass("template-customers-account")) {
    $(".responsive-table__row").click(function () {
      window.location.href = $(this).data("url");
    });
  }

  if (
    $("body").hasClass("template-customers-order") &&
    window.theme.utils.isMobile()
  ) {
    $(".order-table tfoot td[colspan]").attr("colspan", 1);
    $(".order-table tfoot th").attr("colspan", 3);
  }
});
